import { render } from "./financial-sidebar.vue?vue&type=template&id=27b7fc6a"
import script from "./financial-sidebar.vue?vue&type=script&lang=js"
export * from "./financial-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__